import { createReferralsDataFetcherFactory } from "./referralsDataFetcherFactory";
import { getNumericSharesFromSiteOrigins } from "./referralsWidgetFetcherUtils";

export default createReferralsDataFetcherFactory((response: any, { orderedCompareDomains }) => {
    const sourceRecords = Array.isArray(response?.Data)
        ? response.Data
        : Array.isArray(response?.Records)
          ? response.Records
          : null;

    if (!sourceRecords) {
        return response;
    }

    const normalizedRecords = sourceRecords.map((record: any) => {
        const orderedSiteOrigins = getNumericSharesFromSiteOrigins(record?.SiteOrigins, orderedCompareDomains);

        if (!orderedSiteOrigins) {
            return record;
        }

        return {
            ...record,
            SiteOrigins: orderedSiteOrigins,
        };
    });

    return {
        ...response,
        Data: normalizedRecords,
        Records: normalizedRecords,
    };
});
